
<div class="container-fluid py-3">
  <h5 mat-dialog-title>Partager l'article</h5>
  <div mat-dialog-content>
    <share-buttons 
      mat-dialog-content 
      theme="circles-dark"
      [include]="['copy', 'facebook', 'linkedin', 'messenger', 'twitter', 'whatsapp', 'email', 'sms', 'telegram', 'print', 'reddit', 'pinterest', 'line']"
      [showIcon]="true"
      [showText]="false"
      [url]="'https://afrotech-hub.com/'+page+'/' + articleSlug"
      [description]=articleTitle
      twitterAccount="afrotechhub"
      style="text-align: center"
      class="pt-4">
    </share-buttons>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary">Fermer</button>
  </div>
</div>
